import Image from "@components/Image";
import Link from "@components/Link";
import Button from "@components/Button";
import cx from "classnames";
import styles from "./FeaturedItem.module.scss";
// import { usePageContext } from "@providers/PageProvider";
// import { brandStoryPage } from "@utils/helper";
import _ from "lodash";

export default function FeaturedItem({ data }: any) {
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.brief)}>
        <div className={cx(styles.content)}>{_.get(data, "title", "")}</div>
        <div className={cx(styles.quote)}>{_.get(data, "subtitle", "")}</div>
      </div>
      <div className={cx(styles.imageWrapper)}>
        <Image
          wrapperProps={{ className: cx(styles.image) }}
          src={_.get(data, "image.src", {})}
          alt={_.get(data, "image.alt", {})}
          layout="fill"
          objectFit="cover"
        />
        <div className={cx(styles.textContent)}>
          {_.get(data, "content", "")}
        </div>
      </div>
      <div className={styles.textParagraph}>{_.get(data, "paragraph", "")}</div>
      <Image
        speed={0}
        wrapperProps={{ className: cx(styles.image) }}
        src={_.get(data, "logo.src", "") ?? "/brand-story/yellow-bird.svg"}
        alt={_.get(data, "logo.alt", "") ?? "brand-story-image-logo"}
        layout="fill"
        objectFit="contain"
      />
      <Link href={_.get(data, "button.href", "#")} target="_blank">
        <Button
          type="primary"
          color="black"
          label={_.get(data, "button.label")}
        />
      </Link>
    </div>
  );
}
